export const GET_USER_POIS = "GET_USER_POIS";
export const ADD_POI = "ADD_POI";
export const UPDATE_POI = "UPDATE_POI";
export const REMOVE_POI = "REMOVE_POI";
export const GET_POI_WEATHER = "GET_POI_WEATHER";
export const GET_DEFAULT_POI_WEATHER = "GET_DEFAULT_POI_WEATHER";
export const CLEAR_POI_WEATHER = "CLEAR_POI_WEATHER";
export const GET_SYNOPTIC_COMMENT = "GET_SYNOPTIC_COMMENT";
